import classNames from 'classnames';
import * as React from 'react';

import * as styles from './ChatbotMenuPinFilter.css';
import { UIHeading4, UIText1 } from '@cian/ui-kit';
import { IconActionChevronDownSmall16, IconActionChevronUpSmall16 } from '@cian/ui-kit-design-tokens/icons';

type TProps = {
  menuText: string;
};

export const ChatbotMenuPinFilter: React.FC<TProps> = ({ menuText }) => {
  const [isShowText, setIsShowText] = React.useState<boolean>(false);
  const [isTextOverflowing, setIsTextOverflowing] = React.useState<boolean>(false);

  const textRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    const textElement = textRef.current;
    if (textElement && textElement.scrollHeight > textElement.clientHeight) {
      setIsTextOverflowing(true);
    }
  }, [menuText]);

  if (!menuText) {
    return null;
  }

  return (
    <div className={styles['container']}>
      <div ref={textRef} className={classNames(!isShowText && styles['hide-text'])}>
        <UIText1 color="gray60_100">{menuText}</UIText1>
      </div>
      {isTextOverflowing && (
        <div
          data-testid="toggle-button"
          className={classNames(styles['button'])}
          onClick={() => setIsShowText((prev: boolean) => !prev)}
        >
          <UIHeading4 color="primary_100">{isShowText ? 'Свернуть' : 'Развернуть'}</UIHeading4>
          {isShowText ? (
            <IconActionChevronUpSmall16 color="primary_100"></IconActionChevronUpSmall16>
          ) : (
            <IconActionChevronDownSmall16 color="primary_100"></IconActionChevronDownSmall16>
          )}
        </div>
      )}
    </div>
  );
};
